import { UseQueryResult } from "react-query";
import { useRemoteQuery } from "../useRemote/useRemoteQuery";
import { RemoteApiError } from "../useRemote/types";
import { VehicleBlockingEvent } from "../../../components/FleetManagement/types/FleetManagement.types";

export type BlockingEventsCalendarParams = {
  vehicleIds: number[];
  startDate: string; // ISO date
  endDate: string; // ISO date
};

/**
 * Fetches blocking events for calendar view (GET /fleet/blocking-events/calendar).
 */
export function useRemoteFetchBlockingEventsCalendar(
  params: BlockingEventsCalendarParams | null
): UseQueryResult<VehicleBlockingEvent[], RemoteApiError> {
  const enabled =
    params != null &&
    params.vehicleIds.length > 0 &&
    params.startDate.length > 0 &&
    params.endDate.length > 0;

  return useRemoteQuery<VehicleBlockingEvent[], RemoteApiError>({
    queryKey: [
      "fleet",
      "blocking-events",
      "calendar",
      params?.vehicleIds,
      params?.startDate,
      params?.endDate
    ],
    url: "/fleet/blocking-events/calendar",
    params: params
      ? {
          vehicleIds: params.vehicleIds.join(","),
          startDate: params.startDate,
          endDate: params.endDate
        }
      : undefined,
    enabled
  });
}
